// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1hz3B","messages":"Chat_messages__5MtNd","dateDivider":"Chat_dateDivider__1yoI6"};